import api from "../services/api";

/**
 * List invoices for the current user (paginated)
 * @param {number} page - Page number (default 1)
 * @param {number} limit - Items per page (default 20)
 * @returns {Promise} { invoices, total, page, limit, totalPages }
 */
export const listInvoices = async (page = 1, limit = 20) => {
  return api.get("/api/invoices", { params: { page, limit } });
};

/**
 * Get invoice details by ID
 * @param {number} invoiceId
 * @returns {Promise} Invoice object with items
 */
export const getInvoice = async (invoiceId) => {
  return api.get(`/api/invoices/${invoiceId}`);
};

/**
 * Download invoice PDF by ID
 * Triggers browser download via blob URL.
 * @param {number} invoiceId
 * @param {string} [fallbackName] - Fallback filename
 */
export const downloadInvoice = async (invoiceId, fallbackName) => {
  const res = await api.get(`/api/invoices/${invoiceId}/download`, {
    responseType: "blob",
  });

  const blob = new Blob([res.data], { type: "application/pdf" });
  const url = URL.createObjectURL(blob);

  const filename =
    res.headers["content-disposition"]?.match(/filename="(.+)"/)?.[1] ||
    fallbackName ||
    `invoice-${invoiceId}.pdf`;

  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
};
